function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "26.345",
  height: "29.23"
}, props), /*#__PURE__*/React.createElement("path", {
  id: "Path_402",
  "data-name": "Path 402",
  d: "M22.027 10.769v2.923h-4.391v6.577a3.66 3.66 0 11-2.927-3.581v-5.919h5.854V4.923H5.927v23.384h20.491V10.769zM3 3.45A1.456 1.456 0 014.462 2h17.565l7.318 7.308v20.45a1.463 1.463 0 01-1.453 1.472H4.453A1.463 1.463 0 013 29.78z",
  transform: "translate(-3 -2)",
  fill: "#4269a1"
})));